import React from 'react';

interface ZonesSurveilleesContentProps {
  zones: any[];
}

const zoneTypeMap: Record<string, string> = {
  qpv: "Quartier prioritaire de la ville",
  qpvAncienDegrade: "Quartier prioritaire de la ville - ancien ou dégradé",
  qva: "Quartier de veille active",
  zus: "Zone urbaine sensible",
  zfu: "Zone franche urbaine",
  npnru: "Nouveau programme national de renouvellement urbain",
};

const getZoneTypeColor = (zoneType: string): string => {
  const colorMap: Record<string, string> = {
    qpv: '#FF6B6B',
    qpvAncienDegrade: '#FF8E53',
    qva: '#4ECDC4',
    zus: '#45B7D1',
    zfu: '#96CEB4',
    npnru: '#A66DD4',
  };
  return colorMap[zoneType] || '#FF8C00';
};

const ZonesSurveilleesContent: React.FC<ZonesSurveilleesContentProps> = ({ zones }) => {
  if (!zones || zones.length === 0) {
    return (
      <div style={{ marginBottom: '16px', color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>
        Aucune zone surveillée trouvée
      </div>
    );
  }

  return (
    <>
      {zones.map((zone, index) => {
        const properties = zone.properties || {};
        const zoneType = properties.zoneType || '';
        const zoneTypeLabel = zoneTypeMap[zoneType] || zoneType;
        
        return (
          <div key={index}>
            {zoneTypeLabel && (
              <div style={{ marginBottom: '16px' }}>
                <strong style={{ color: '#333' }}>Type:</strong> {zoneTypeLabel}
              </div>
            )}
            
            {properties.CODQUART && (
              <div style={{ marginBottom: '16px' }}>
                <strong style={{ color: '#333' }}>Code quartier:</strong> {properties.CODQUART}
              </div>
            )}
            
            {properties.CODE_QP && (
              <div style={{ marginBottom: '16px' }}>
                <strong style={{ color: '#333' }}>Code QP:</strong> {properties.CODE_QP}
              </div>
            )}
            
            {/* {properties.TYPE && (
              <div style={{ marginBottom: '16px' }}>
                <strong style={{ color: '#333' }}>Type détaillé:</strong> {properties.TYPE}
              </div>
            )}
            
            {properties.LIBELLE && (
              <div style={{ marginBottom: '16px' }}>
                <strong style={{ color: '#333' }}>Libellé:</strong> {properties.LIBELLE}
              </div>
            )}
            
            {properties.NOM && (
              <div style={{ marginBottom: '16px' }}>
                <strong style={{ color: '#333' }}>Nom:</strong> {properties.NOM}
              </div>
            )} */}
            
            {index < zones.length - 1 && (
              <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />
            )}
          </div>
        );
      })}
    </>
  );
};

export default ZonesSurveilleesContent;
